import { devLog } from "utils/logger";

const iosBridge = {
    setTokenResponse: () => {},
    getTokenResponse: () => {},
    getFaceIdToken: () => {},
    closeWebView: () => {},
    faceIdCallback: (token) => {
      devLog('Face ID 토큰 수신:', token);
      // 토큰 처리 로직
  }
  };
  
  if (!window.iosBridge) {
    window.iosBridge = iosBridge;
  }
  
  export default iosBridge;